// import initialState from '../store/initialState';
import { Types } from '../actions/actionTypes';
import initialState from '../store/initialState'


export const setactiveDeviceReducer = (state = initialState.setactiveDevice, action) => {
    console.log("set device reducer------->", action)
    switch (action.type) {
        case Types.DEVICE_TYPE:
            console.log("setting Setdevice reducer---------->", action.payload)
            return {
                ...state,
                device: action.payload
            };

        default:
            return state;
    };


};